import React, { useEffect } from "react";
import { SaveBar as AppBridgeSaveBar } from "@shopify/app-bridge-react";

const SAVE_BAR_ID = "uso-save-bar";

const SaveBar = ({ onDiscard, onSave, saveLoading, visible }) => {
  // https://github.com/Shopify/shopify-app-bridge/issues/281
  const loading = saveLoading ? "" : undefined;

  const handleDiscard = e => {
    // Save bar clicks might submit forms, so we need to prevent that
    e.preventDefault();
    e.stopPropagation();

    onDiscard();
  };

  useEffect(() => {
    if (visible) {
      shopify.saveBar.show(SAVE_BAR_ID);
    } else {
      shopify.saveBar.hide(SAVE_BAR_ID);
    }
  }, [visible]);

  return (
    <AppBridgeSaveBar id={SAVE_BAR_ID}>
      <button variant="primary" onClick={onSave} loading={loading} />
      <button onClick={handleDiscard} />
    </AppBridgeSaveBar>
  );
};

export function hide() {
  shopify.saveBar.hide(SAVE_BAR_ID);
}

export function leave() {
  return shopify.saveBar.leaveConfirmation(SAVE_BAR_ID);
}

/**
 * The SaveBar inconsistently blocks the browser back button - it only works on
 * non-nested routes. This function adds a listener
 * to just hide the save bar when navigating back.
 *
 * Initially implemented in the Wholesale Hub App.
 * Refactored for the Ultimate Special Offers app that uses different library versions:
 * react-router-dom v5 vs v6.
 */
export function setupBackNavigationSaveBarHandler(appHistory) {
  // Prefer listening to the same history instance the app uses so we get POP events reliably
  if (appHistory && typeof appHistory.listen === "function") {
    appHistory.listen((_location, action) => {
      if (action === "POP") {
        try {
          shopify.saveBar.hide(SAVE_BAR_ID);
        } catch {
          // if the merchant is navigating from a page without a SaveBar
        }
      }
    });
  }
}
export default SaveBar;
